import { MatchingOverview } from '../translations-types';

const translations: MatchingOverview = {
  dateTime: 'Datum/tijd',
  appointment: 'Afspraak',
  status: 'Status',
  customer: 'Klant',
  voorzorg: 'Voorzorg',
  nazorg: 'Nazorg',
  matched: 'Gekoppeld',
  unmatched: 'Niet gekoppeld',
  ambiguous: 'Meerdere matches',
  noAttendee: 'Geen naam',
  noResults: 'Geen afspraken in de afgelopen 7 dagen.',
};

export default translations;
